(function ($) {
  'use strict';

  /**
   * Mega Menu Controls
   */


  /**
   * Prep Buttons & Containers
   */

  var $main_nav_dropdown_links = $('.navigation--main > ul > li:is( .js-menu-item-mega, .menu-item-has-children ) > a');

  // Convert main nav dropdown links into buttons
  $main_nav_dropdown_links.each(function () {
    $(this).replaceWith( $( '<button class="js-mega-menu-dropdown" aria-expanded="false" type="button">' + this.innerHTML + '</button>' ) );
  });

  // Get all buttons & dropdowns, for toggle
  var $main_nav_dropdown_buttons = $('.navigation--main .js-mega-menu-dropdown');
  var $main_nav_dropdown_sub_menus = $('.navigation--main > ul > li > ul.sub-menu, .mega-menu-dropdown');

  // Prep buttons
  $main_nav_dropdown_buttons.each(function () {
    var $this = $(this);
    var $this_parent = $this.parent( 'li' );
    var $this_sub_menu = $this_parent.find( '> ul.sub-menu' );
    var parent_id = $this_parent.attr( 'id' );
    var this_button_id = parent_id + '-button';
    var this_sub_menu_id = parent_id + '-sub-menu';

    // Handle Products Mega Menu Dropdown
    if ( $this_parent.hasClass( 'js-menu-item-mega--products' ) ) {
      // aria-controls - Use mega menu container ID
      $this.attr( 'aria-controls', 'main-nav-products-mega-menu' );
      // Move mega menu under this sction, to preserve tab order & handle positioning
      $('#main-nav-products-mega-menu').appendTo( $this_parent );
      return true;
    }

    // Apply Aria Conrols ID for sub-menus
    $this_sub_menu.attr( 'id', this_sub_menu_id );
    $this.attr( 'id', this_button_id );
    $this.attr( 'aria-controls', this_sub_menu_id );
  });


  /**
   * Button Controls
   */

  // Handle Clicks
  $main_nav_dropdown_buttons.on('click', function () {
    var $this = $(this);
    var $this_sub_menu = $( '#' + $this.attr( 'aria-controls' ) );
    var is_aria_expanded = ( $this.attr( 'aria-expanded' ) === 'true' ) || false;

    // Close all open
    $main_nav_dropdown_buttons.attr( 'aria-expanded', 'false' );
    $main_nav_dropdown_sub_menus.removeClass( 'is-active' );

    // Open just this
    if ( is_aria_expanded === false ) {
      $this.attr( 'aria-expanded', 'true' );
      $this_sub_menu.addClass( 'is-active' );
    }
  });


  // Close on esc keypress
  $(document).on('keydown', function (e) {
    if ( e.key === 'Escape' ) {
      // Close all open
      $main_nav_dropdown_buttons.attr( 'aria-expanded', 'false' );
      $main_nav_dropdown_sub_menus.removeClass( 'is-active' );
    }
  });


  // Close on click & tab outside
  $(document).on('click focusin', function (e) {
    if ( $main_nav_dropdown_sub_menus.is(':visible') ) {
      var $parent = $main_nav_dropdown_sub_menus.closest( 'header' );

      if ( ! $(e.target).closest( $parent ).length ) {
        $main_nav_dropdown_buttons.attr( 'aria-expanded', 'false' );
        $main_nav_dropdown_sub_menus.removeClass( 'is-active' );
      }
    }
  });


})(jQuery);
